import ProductImage from './product_image';
export default ProductImage;
